import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { formatDate } from '@angular/common';

/**
 * Calendar-like month picker (year navigation + month grid) for values in the
 * yyyy-MM format; the native input[type=month] falls back to a plain text
 * field on Safari and Firefox.
 */
@Component({
  selector: 'app-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.scss'],
  standalone: false,
})
export class MonthPickerComponent {
  @Input() label = 'Month';
  @Input() value: string | null = null;
  @Output() valueChange = new EventEmitter<string>();

  open = false;
  displayYear = new Date().getFullYear();

  readonly monthNames = Array.from({ length: 12 }, (_, i) =>
    formatDate(new Date(2000, i, 1), 'MMM', 'en'),
  );

  constructor(private elementRef: ElementRef) {}

  get displayValue(): string {
    return this.value ? formatDate(`${this.value}-01`, 'MMMM yyyy', 'en') : '';
  }

  private get selectedYear(): number | null {
    return this.value ? +this.value.substring(0, 4) : null;
  }

  private get selectedMonth(): number | null {
    return this.value ? +this.value.substring(5, 7) : null;
  }

  toggle() {
    this.open = !this.open;
    if (this.open) {
      this.displayYear = this.selectedYear ?? new Date().getFullYear();
    }
  }

  isSelected(monthIndex: number): boolean {
    return (
      this.selectedYear === this.displayYear &&
      this.selectedMonth === monthIndex + 1
    );
  }

  select(monthIndex: number) {
    const month = String(monthIndex + 1).padStart(2, '0');
    this.value = `${this.displayYear}-${month}`;
    this.valueChange.emit(this.value);
    this.open = false;
  }

  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: MouseEvent) {
    if (this.open && !this.elementRef.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }
}
